import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["accept", "multiple"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", {
      hidden: "",
      ref: "file",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
      type: "file",
      accept: _ctx.$attrs.accept,
      multiple: _ctx.$attrs.multiple
    }, null, 40, _hoisted_1),
    _renderSlot(_ctx.$slots, "default", {
      props: {to_upload: _ctx.to_upload, uploading: _ctx.uploading, errors: _ctx.errors},
      methods: {open: _ctx.open,remove: _ctx.remove,reset: _ctx.reset}
    })
  ], 64))
}